// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"4cde12880862d4d3bb0b","655":"54b9e70ebd01672a8acc"}[chunkId] + ".js";
};